import serviceAxios from "../index"


export const getProductCategory = (params) => {
  return serviceAxios({
    url: "/api/product/category",
    method: "get",
    params,
  })
}

export const getProductList = (params) => {
  return serviceAxios({
    url: "/api/product/list",
    method: "get",
    params,
  })
}



// WEBPACK FOOTER //
// ./src/http/api/product.js